<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Bank </label>
                                    <multiselect
                                        v-model="GlobalBank"
                                        :options="bank_master1"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        track-by="BANK_ID"
                                        label="Bank_Name"
                                        :show-labels="false"
                                        @input="afterBankSelect"
                                        :close-on-select="true"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>Branch Code </label>
                                    <multiselect
                                        v-model="GlobalBankBranch"
                                        :options="Bank_Branch_Master_For_Bank"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        track-by="BANK_BRACH_ID"
                                        label="Bank_Branch_Code"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label> Product </label>
                                    <multiselect
                                        v-model="GlobalProduct"
                                        :options="Product_Master_For_Bank"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        track-by="PRODUCT_ID"
                                        label="Product_Name"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label> Start Date </label>
                                    <input type="date" v-model="startDate" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label> End Date </label>
                                    <input type="date" v-model="endDate" />
                                </div>
                            </div>
                            <div
                                class="col-md-4"
                                v-if="
                                    userglobaldata.User_Status == 'SuperAdmin'
                                "
                            >
                                <div class="form-group">
                                    <label> Admins </label>
                                    <multiselect
                                        v-model="GlobalAdmin"
                                        :options="Admin_Master"
                                        :allow-empty="true"
                                        open-direction="bottom"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label="name"
                                        :close-on-select="true"
                                        aria-required="true"
                                    >
                                    </multiselect>
                                </div>
                            </div>

                            <div class="col-md-2 col-xs-2 column bt-column2">
                                <div class="form-group">
                                    <button
                                        class="btn btn-success"
                                        @click="loadAndSearchClientForAssign(1)"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">
                            Applicant List Total:-{{ ClientTotalCount }}
                        </h3>

                        <div class="card-tools">
                            <input
                                class="btn search_box"
                                type="text"
                                placeholder="LoginId/Applicant"
                                @keyup="searchit"
                                v-model="search"
                                aria-label="Search"
                            />
                            <!-- <button class="btn btn-success" @click="newClient()">Add New</button> -->
                            <button
                                v-if="selected.length"
                                class="btn btn-primary"
                                @click="AssigntoEmployeeModel()"
                            >
                                Allocation <i class="fas fa-tasks"></i>
                            </button>
                            <button
                                v-if="!selected.length"
                                class="btn btn-primary"
                                disabled
                            >
                                Allocation <i class="fas fa-tasks"></i>
                            </button>
                            <button
                                class="btn btn-info"
                                @click="selectalllist()"
                            >
                                Checked All Seen<i
                                    class="fas fa-check-square"
                                ></i>
                            </button>
                        </div>
                    </div>
                    <!-- /.card-header -->
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                            <tr>
                                <th>
                                    <!-- <div class="pretty p-svg p-curve">
                                    <input
                                        type="checkbox"
                                        v-model="selectAll"
                                        @click="select"
                                    />
                                </div> -->
                                </th>
                                <th>Login Id</th>
                                <th>Bank Name</th>
                                <th>Branch Code</th>
                                <th>Product Name</th>
                                <th>Applicant Name</th>
                                <th>Residential Address</th>
                                <th>Residential Mobile Number</th>
                                <th>Office Address</th>
                                <th>Office Mobile Number</th>
                                <th>Created At</th>
                                <th>Modify</th>
                            </tr>
                            <tr
                                v-for="client_master in client_masters.data"
                                :key="client_master.CLIENT_ID"
                            >
                                <td>
                                    <div class="pretty p-icon">
                                        <input
                                            type="checkbox"
                                            :value="client_master"
                                            v-model="selected"
                                        />
                                    </div>
                                </td>
                                <td>{{ client_master.Login_Id }}</td>
                                <td>{{ client_master.Bank_Name }}</td>
                                <td>{{ client_master.Bank_Branch_Code }}</td>
                                <td>{{ client_master.Product_Name }}</td>
                                <td>{{ client_master.Applicant_Name }}</td>
                                <td>{{ client_master.Residential_Address }}</td>
                                <td>
                                    {{
                                        client_master.Contact_Person_Mobile_Number
                                    }}
                                </td>
                                <td>{{ client_master.Office_Address }}</td>
                                <td>
                                    {{ client_master.Office_Mobile_Number }}
                                </td>
                                <td>
                                    {{
                                        customDateFormatter(
                                            client_master.created_at
                                        )
                                    }}
                                </td>
                                <td>
                                    <a
                                        href="#"
                                        @click="editClient(client_master)"
                                        ><i class="fas fa-edit"></i></a
                                    >/
                                    <a
                                        href="#"
                                        @click="
                                            deleteClient(
                                                client_master.CLIENT_ID
                                            )
                                        "
                                        ><i class="fas fa-trash-alt red"></i
                                    ></a>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                <pagination
                                    :data="client_masters"
                                    @pagination-change-page="
                                        loadAndSearchClientForAssign
                                    "
                                    :limit="this.$PaginationCounterLimit"
                                >
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchClientForAssign(1)"
                                    aria-required="true"
                                >
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.card -->
            </div>
        </div>
        <!-- /.row -->
        <!-- Modal -->
        <div
            class="modal fade"
            id="Client_Model"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5
                            class="modal-title"
                            v-show="!editmode"
                            id="exampleModalLabel"
                        >
                            Add New Client
                        </h5>
                        <h5
                            class="modal-title"
                            v-show="editmode"
                            id="exampleModalLabel"
                        >
                            Update Client
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form
                        @submit.prevent="
                            editmode ? UpdateClient() : CreateClientMaster()
                        "
                        @keydown="form.onKeydown($event)"
                    >
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Login Id</label>
                                        <input
                                            v-model="form.Login_Id"
                                            type="text"
                                            name="Login_Id"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Login_Id'
                                                )
                                            }"
                                        />
                                        <has-error
                                            :form="form"
                                            field="Login_Id"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Bank Name</label>
                                        <multiselect
                                            v-model="form.BANK_ID_REF"
                                            :options="bank_master"
                                            :allow-empty="false"
                                            open-direction="bottom"
                                            deselect-label="Can't remove this value"
                                            label="Bank_Name"
                                            track-by="BANK_ID"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'BANK_ID_REF'
                                                )
                                            }"
                                            @input="onFormBankChange"
                                            aria-required="true"
                                        >
                                        </multiselect>
                                        <has-error
                                            :form="form"
                                            field="Bank_Name"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Bank Branch</label>
                                        <multiselect
                                            v-model="form.BANK_BRANCH_ID_REF"
                                            :options="bank_branch_master"
                                            :allow-empty="false"
                                            open-direction="bottom"
                                            deselect-label="Can't remove this value"
                                            label="Bank_Branch_Name"
                                            track-by="BANK_BRANCH_ID"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'BANK_BRANCH_ID_REF'
                                                )
                                            }"
                                            @input="loadBankWithProduct"
                                            aria-required="true"
                                        >
                                        </multiselect>
                                        <has-error
                                            :form="form"
                                            field="BANK_BRANCH_ID"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Product Name</label>
                                        <multiselect
                                            v-model="form.PRODUCT_ID_REF"
                                            :options="Product_Master_For_Bank"
                                            :allow-empty="false"
                                            open-direction="bottom"
                                            deselect-label="Can't remove this value"
                                            label="Product_Name"
                                            track-by="PRODUCT_ID"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'PRODUCT_ID_REF'
                                                )
                                            }"
                                            aria-required="true"
                                        >
                                        </multiselect>
                                        <has-error
                                            :form="form"
                                            field="Product_Name"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Applicant Name</label>
                                        <input
                                            v-model="form.Applicant_Name"
                                            type="text"
                                            name="Applicant_Name"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Applicant_Name'
                                                )
                                            }"
                                        />
                                        <has-error
                                            :form="form"
                                            field="Applicant_Name"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Residential Address</label>
                                        <textarea
                                            v-model="form.Residential_Address"
                                            type="text"
                                            name="Residential_Address"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Residential_Address'
                                                )
                                            }"
                                        ></textarea>
                                        <has-error
                                            :form="form"
                                            field="Residential_Address"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label
                                            >Contact Person Mobile Number</label
                                        >
                                        <input
                                            v-model="
                                                form.Contact_Person_Mobile_Number
                                            "
                                            type="text"
                                            name="Contact_Person_Mobile_Number"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Contact_Person_Mobile_Number'
                                                )
                                            }"
                                        />
                                        <has-error
                                            :form="form"
                                            field="Contact_Person_Mobile_Number"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Office Address</label>
                                        <textarea
                                            v-model="form.Office_Address"
                                            type="text"
                                            name="Office_Address"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Office_Address'
                                                )
                                            }"
                                        ></textarea>
                                        <has-error
                                            :form="form"
                                            field="Office_Address"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Office Mobile Number</label>
                                        <input
                                            v-model="form.Office_Mobile_Number"
                                            type="text"
                                            name="Office_Mobile_Number"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Office_Mobile_Number'
                                                )
                                            }"
                                        />
                                        <has-error
                                            :form="form"
                                            field="Office_Mobile_Number"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Loan Amount</label>
                                        <input
                                            v-model="form.Loan_Amount"
                                            type="text"
                                            name="Loan_Amount"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Loan_Amount'
                                                )
                                            }"
                                        />
                                        <has-error
                                            :form="form"
                                            field="Loan_Amount"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Executive Location</label>
                                        <multiselect
                                            v-model="form.Location"
                                            :options="Location_Master"
                                            :allow-empty="false"
                                            open-direction="bottom"
                                            deselect-label="Can't remove this value"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Location'
                                                )
                                            }"
                                            aria-required="true"
                                        >
                                        </multiselect>
                                        <has-error
                                            :form="form"
                                            field="Location"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>FI Bank Location</label>
                                        <multiselect
                                            v-model="form.Fi_Bank_Location"
                                            :options="Location_Master"
                                            :allow-empty="false"
                                            open-direction="bottom"
                                            deselect-label="Can't remove this value"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Fi_Bank_Location'
                                                )
                                            }"
                                            aria-required="true"
                                        >
                                        </multiselect>
                                        <has-error
                                            :form="form"
                                            field="Fi_Bank_Location"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <label>Office Name</label>
                                        <input
                                            v-model="form.Office_Name"
                                            type="text"
                                            name="Office_Name"
                                            class="form-control"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Office_Name'
                                                )
                                            }"
                                        />
                                        <has-error
                                            :form="form"
                                            field="Office_Name"
                                        ></has-error>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <label>Company Name</label>
                                        <multiselect
                                            v-model="form.Company_Name"
                                            :options="Company_Name_Master"
                                            :allow-empty="false"
                                            open-direction="bottom"
                                            deselect-label="Can't remove this value"
                                            :class="{
                                                'is-invalid': form.errors.has(
                                                    'Company_Name'
                                                )
                                            }"
                                            aria-required="true"
                                        >
                                        </multiselect>
                                        <has-error
                                            :form="form"
                                            field="Company_Name"
                                        ></has-error>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-danger"
                                    data-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    v-show="!editmode"
                                    class="btn btn-primary"
                                >
                                    Save Client
                                </button>
                                <button
                                    type="submit"
                                    v-show="editmode"
                                    class="btn btn-success"
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!--end Model-->
    </div>
</template>

<script>
import ToastTemplet from "../widget/toast";
export default {
    props: ["userglobaldata"],
    components: { Multiselect, ToastTemplet },
    data() {
        return {
            toast: new Vue(),
            startDate: "",
            endDate: "",
            editmode: false,
            Product_Master: [],
            Product_Master_For_Bank: [],
            Bank_Branch_Master_For_Bank: [],
            search: "",
            client_masters: {},
            GlobalBank: "",
            GlobalBankBranch: "",
            bank_master: [],
            bank_master1: [],
            bank_branch_master: [],
            GlobalProduct: "",
            GlobalAdmin: "",
            Admin_Master: [],
            selected: [],
            selectAll: false,
            selectedData: [],
            ClientTotalCount: "",

            Location_Master: ["local", "out", "osg"],
            Company_Name_Master: [
                "SARVOTTAM CONSULTANT",
                "SARVOTTAM VERIFICATION SERVICES PRIVATE LIMITED"
            ],
            form: new Form({
                CLIENT_ID: "",
                Login_Id: "",
                BANK_ID_REF: "",
                BANK_BRANCH_ID_REF: "",
                BANK_BRANCH_ID: "",
                PRODUCT_ID_REF: "",
                Product_Name: "",
                Applicant_Name: "",
                Residential_Address: "",
                Contact_Person_Mobile_Number: "",
                Office_Address: "",
                Office_Mobile_Number: "",
                Loan_Amount: "",
                Location: "",
                Fi_Bank_Location: "",
                Company_Name: "",
                Office_Name: ""
            })
        };
    },
    created() {
        Fire.$on("searching", () => {
            this.loadAndSearchClientForAssign();
        });
        Fire.$on("AfterChangeClient", () => {
            this.loadAndSearchClientForAssign();
        });
    },
    mounted() {
        this.loadAllProduct();
        this.loadAndSearchClientForAssign();
        this.loadBankWithProduct();
        this.loadBankBranch();
        this.loadAdmins();
        this.loadBank();
    },
    methods: {
        searchit: _.debounce(() => {
            Fire.$emit("searching");
        }, 500),
        // loadBank(){
        //     axios.get('/loadBank')
        //     .then(({data})=> {this.bank_master = data})
        //     .catch(() => {
        //         this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
        //     });
        // },
       selectalllist() {
            if (this.selected.length === this.client_masters.data.length) {
                // Unselect all
                this.selected = [];
            } else {
                // Select all
                this.selected = [...this.client_masters.data];
            }
        },
        loadBank() {
            axios
                .get("/loadBank")
                .then(({ data }) => {
                    this.bank_master1 = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        onFormBankChange() {
            const bankId = this.form.BANK_ID_REF?.BANK_ID;
            if (!bankId) return;

            axios.get(`/afterselect_bank/${bankId}`).then(({ data }) => {
                this.bank_branch_master = data;
                this.form.BANK_BRANCH_ID_REF = null; // clear old branch
            });

            axios.get(`/loadProductBankWise/${bankId}`).then(({ data }) => {
                this.Product_Master_For_Bank = data;
                this.form.PRODUCT_ID_REF = null; // clear old product
            });
        },
        afterselect_bank() {
            axios
                .get("/afterselect_bank/" + this.GlobalBank.BANK_ID)
                .then(({ data }) => {
                    this.Bank_Branch_Master_For_Bank = data;
                }, (this.form.BANK_BRANCH_ID_REF = ""))
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        afterBankSelect() {
            this.afterselect_bank();
            axios
                .get("/loadProductBankWise/" + this.GlobalBank.BANK_ID)
                .then(({ data }) => {
                    this.Product_Master_For_Bank = data;
                }, (this.form.PRODUCT_ID_REF = ""))
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadBankWithProduct() {
            axios
                .get("/loadBankWithProduct")
                .then(({ data }) => {
                    this.bank_master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadAdmins() {
            axios
                .get("/loadAdmins")
                .then(({ data }) => {
                    this.Admin_Master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadBankBranch() {
            axios
                .get("/loadBankBranch")
                .then(({ data }) => {
                    this.bank_branch_master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        select() {
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.client_masters.data) {
                    this.selected.push(this.client_masters.data[i]);
                }
            }
        },
        loadAllProduct() {
            axios
                .get("/loadAllProduct")
                .then(({ data }) => {
                    this.Product_Master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        UpdateClient() {
            this.toast.$emit("LoadingOn");
            this.form
                .put("client/" + this.form.CLIENT_ID)

                .then(() => {
                    Fire.$emit("AfterChangeClient");
                    $("#Client_Model").modal("hide");
                    this.toast.$emit(
                        "LoadingOffSuccess",
                        "Client Updated successfully"
                    );
                })
                .catch(() => {
                    this.toast.$emit(
                        "LoadingOffError",
                        "your request could not be processed."
                    );
                });
        },
        editClient(client_master) {
            (this.editmode = true), this.form.reset();
            $("#Client_Model").modal("show");
            this.form.fill(client_master);

            this.form.BANK_ID_REF = {
                BANK_ID: client_master.BANK_ID,
                Bank_Name: client_master.Bank_Name
            };
            this.form.PRODUCT_ID_REF = {
                PRODUCT_ID: this.form.PRODUCT_ID_REF,
                Product_Name: this.form.Product_Name
            };
            this.form.BANK_BRANCH_ID_REF = {
                BANK_BRANCH_ID: this.form.BANK_BRANCH_ID_REF,
                Bank_Branch_Name: client_master.Bank_Branch_Code
            };
        },
        newClient() {
            (this.editmode = false), this.form.reset();
            $("#Client_Model").modal("show");
        },
        AssigntoEmployeeModel() {
            this.form.reset();
            this.$router.push({
                name: "AllocationList",
                params: { AllocationList: this.selected }
            });
        },
        deleteClient(CLIENT_ID) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then(result => {
                if (result.value) {
                    this.form
                        .delete("client/" + CLIENT_ID)
                        .then(() => {
                            Fire.$emit("AfterChangeClient");
                            this.toast.$emit(
                                "SwalSuccess",
                                "Deleted!",
                                "Client Deleted."
                            );
                        })
                        .catch(() => {
                            this.toast.$emit(
                                "SwalWarning",
                                "Failed!",
                                "There was something wrong, Or Client Is Already In Use"
                            );
                        });
                }
            });
        },
        CreateClientMaster() {
            this.toast.$emit("LoadingOn");
            this.form.Loan_Amount = this.form.Loan_Amount.toString().replace(
                /[^0-9]/g,
                ""
            );
            this.form
                .post("client")
                .then(() => {
                    $("#Client_Model").modal("hide");
                    // this.loadAndSearchClientForAssign();
                    Fire.$emit("AfterChangeClient");
                    this.toast.$emit(
                        "LoadingOffSuccess",
                        "Client Create successfully"
                    );
                })
                .catch(() => {
                    this.toast.$emit("LoadingOffError", "your Request Failed.");
                });
        },
        loadAndSearchClientForAssign(page = 1) {
            var productid, bankid, bankBranchCode, bankBranchId, AdminId;
            if (this.GlobalProduct == null) {
                productid = "undefined";
            } else {
                productid = this.GlobalProduct.PRODUCT_ID;
            }
            if (this.GlobalAdmin == null) {
                AdminId = "undefined";
            } else {
                AdminId = this.GlobalAdmin.id;
            }
            if (this.GlobalBank == null) {
                bankid = "undefined";
            } else {
                bankid = this.GlobalBank.BANK_ID;
            }
            if (this.GlobalBankBranch == null) {
                bankBranchId = "undefined";
            } else {
                bankBranchId = this.GlobalBankBranch.BANK_BRANCH_ID;
            }
            this.toast.$emit("ProgressBarLoading");
            axios
                .get(
                    "loadAndSearchClientForAssign?query=" +
                        this.search +
                        "&adminId=" +
                        AdminId +
                        "&bankBranchId=" +
                        bankBranchId +
                        "&page=" +
                        page +
                        "&PaginationLimit=" +
                        this.$PaginationLimit +
                        "&startDate=" +
                        this.startDate +
                        "&endDate=" +
                        this.endDate +
                        "&bankId=" +
                        bankid +
                        "&productId=" +
                        productid
                )
                .then(({ data }) => {
                    (this.client_masters = data),
                        (this.ClientTotalCount = data.total),
                        this.toast.$emit("ProgressBarFinish");
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any Such User"
                    );
                });
        }
    }
};
</script>
